import { AxiosRequestConfig, AxiosPromise } from '../types/index.ts';
import http from './fetch.ts';
import { buildURL } from '../helpers/url.ts';
import { transformRequest, transformResponse } from '../helpers/data.ts';
import { processHeaders } from '../helpers/headers.ts';
import VerifyRequest from '../../verify_request.ts';

function dispatchRequest(config: AxiosRequestConfig): AxiosPromise {
  processConfig(config);
  return http(config)
    .then((res) => {
      return transformResponseData(res);
    })
    .catch((error) => {
      return transformErrorResponse(error);
    });
}

function processConfig(config: AxiosRequestConfig): void {
  config.headers = transformHeaders(config);
  config.data = transformRequestData(config);
  config.url = transformURL(config);
}

function transformHeaders(config: AxiosRequestConfig): any {
  const { headers = {}, data } = config;
  // 在处理成字符串之前 把站外传进来的body加上
  const dynamicHeaders =
    typeof VerifyRequest.headers === 'function' ? VerifyRequest.headers() : {};
  Object.assign(headers, dynamicHeaders);
  return processHeaders(headers, data);
}

function transformRequestData(config: AxiosRequestConfig): any {
  let { data } = config;
  const dynamicData =
    typeof VerifyRequest.data === 'function' ? VerifyRequest.data() : {};
  data &&
    data.validate_param &&
    Object.assign(data.validate_param, dynamicData);
  return transformRequest(data);
}

function transformURL(config: AxiosRequestConfig): string {
  const { url = '', params } = config;
  return buildURL(url, params);
}

function transformResponseData(res: any): any {
  res.data = transformResponse(res.data);
  return res;
}
function transformErrorResponse(error: string | number) {
  return {
    code: 9002,
    msg: `${error}`,
    info: `${error}`,
  };
}

export default dispatchRequest;
